import Vue from 'vue'
import Vuex from 'vuex'
import pathify from 'vuex-pathify'

// modules
import strategy from './modules/strategy'
import goal from './modules/goal'
import generalComment from './modules/general-comment'
import notification from './modules/notification'
import filters from './modules/filters'
import currentUser from './modules/current-user'
import pdi from './modules/pdi'
import defaultFilters from './people/defaultFilters'
import nBoxesReport from './modules/n-box/report'
import questionnairesResults from './modules/values/questionnaires-results'
import okr from './modules/okr'
import profile from './modules/profile'
import feed from './modules/feed'
import daily from './modules/daily'
import locale from './modules/locale'

Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [pathify.plugin],
    modules: {
        strategy,
        goal,
        notification,
        filters,
        generalComment,
        currentUser,
        pdi,
        defaultFilters,
        nBoxesReport,
        questionnairesResults,
        okr,
        profile,
        feed,
        daily,
        locale,
    },
})
